export interface IPromocode {
  id?: number;
  cityId?: number | null;
  pincode?: number | null;
  mobile?: number | null;
  active?: boolean | null;
  code?: string | null;
  discount?: number | null;
  minAmount?: number | null;
  maxAmount?: number | null;
  userMobile?: string | null;
}

export const defaultValue: Readonly<IPromocode> = {
  active: false,
};
